<template>
    <div class="imageHolder" v-if="isImageOpen" @click.self="isImageOpen = false">
        <div class="frame">
            <div class="image" :style="{ 'background-image': 'url('+ this.$store.state.imagesURL + setAlbum + '/' + this.setArray[this.setImage] + '.jpg)' }" @click="ChangeImage(isPrev)" @mousemove="ViewMouseX($event)" ref="imageBlock">
                <iframe v-if="GetImageType() == 2" width="100%" height="100%" :src="GetYouTubeId()" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                <button type="button" class="btn btn-danger btn-close" @click="isImageOpen = false"><i class="glyphicon glyphicon-remove"></i></button>
                <div class="imageButtonLeft" :class="isPrev?'arrowHover':'none'"><span class="glyphicon glyphicon-chevron-left imageButtonArrow"></span></div>
                <div class="imageButtonRight" :class="isPrev?'none':'arrowHover'"><span class="glyphicon glyphicon-chevron-right"></span></div>
            </div>
            {{setImage+1}}/{{setArray.length}}
        </div>
    </div>
</template>

<script>
export default {
  name: 'PopImage',
  data: () => ({
      isImageOpen: false,
      isMoreDetails: false,
      isPrev: false,
      setImage: 0,
      setAlbum: 'none',
      setArray: ['none']
  }),
  methods: {
    GetImageType(){
        let settype = 1 // - 1 - image, 2 - video
        let img = this.setArray[this.setImage]
        if (img.indexOf("youtube.com") >= 0 | img.indexOf("youtu.be") >= 0) settype = 2
        return settype
    },
    GetYouTubeId(){
        let img = this.setArray[this.setImage]
        let imgurl = "https://www.youtube.com/embed/"
        let imgid =  /^https?\:\/\/(www\.)?youtu\.be/.test(img) ? img.replace(/^https?\:\/\/(www\.)?youtu\.be\/([\w-]{11}).*/,"$2") : img.replace(/.*\?v\=([\w-]{11}).*/,"$1");
        //alert (imgurl+imgid)
        return imgurl+imgid
    },
    NewTabUrlOpen(val){
        //alert(val)
        window.open(val, '_blank')
    },
    ChangeImage() {
        console.log (this.isPrev)
        this.isPrev?this.ShowPrev():this.ShowNext()
    },
    ShowNext() {
        if(this.setImage < this.setArray.length-1){
            this.setImage += 1
        }
        else {
            this.setImage = 0
        }
    },
    ShowPrev() {
        if(this.setImage > 0){
            this.setImage -= 1
        }
        else {
            this.setImage = this.setArray.length-1
        }
    },
    ViewMouseX(event){
        let obj = this.$refs['imageBlock']
        let objSet = obj.getBoundingClientRect()
        let objx1 = objSet.x
        let objx2 = objx1 + objSet.width
        let xcoord = (event.clientX-objx1)/objx2
        if (xcoord <= 0.25) this.isPrev = true
        else this.isPrev = false
    }
  },
  created: function () {
        this.$root.$on('ImageShow', (val,alb,arr) =>  {
            this.isImageOpen = true
            this.setImage = val
            this.setAlbum = alb
            this.setArray = arr
        })        
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn-close {
  position: absolute;
  right: -15px;
  top: -15px;
  width: 30px;
  height: 30px;
  text-align: center;
  padding: 5px 0;
  font-size: 15px;
  line-height: 15px;
  border-radius: 15px;
  z-index: 10;
}
.imageHolder {
    position: fixed;
    z-index: 500;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    padding: 0;
    background-color: rgba(0,0,0,0.7);    
}
.imageHolder .frame {
    display:inline-block;
    margin-top: 5vh;   
    margin-left: auto;
    margin-right: auto;
    height: auto;
    min-width:50%;    
    width: auto;
    padding: 3px 3px 3px 3px;
    line-height: 50px;
    background-color: rgba(255,255,255,0.9);
    box-shadow: 0 4px 2px -2px rgba(0,0,0,0.4);
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently */
}
.imageHolder .frame .image {
    position: relative;
    padding: 0px 35px;
    display: block;
    background-color: #222222;
    height: 80vh;
    width: 80vw;
    background-image: url('http://wheres-it.net/wp-content/uploads/2018/06/CrossOut.jpg');
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
}
.imageButtonLeft {
    position: absolute;
    display: inline-block;
    left: 0px;
    width: 35px;
    border-radius: 0px;
    z-index: 9;
    font-size: 25px;
    color: #ffffff;
    text-shadow: 2px 2px 3px rgba(0,0,0,0.6);
    margin: 0, auto;
    top: 50%;
    transform: translate(0,-50%) !important;
    opacity: 0.5;
}
.imageButtonRight {
    position: absolute;
    display: inline-block;
    right: 0px;
    width: 35px;
    border-radius: 0px;
    z-index: 9;
    font-size: 25px;
    color: #ffffff;
    text-shadow: 2px 2px 3px rgba(0,0,0,0.6);
    margin: 0, auto;
    top: 50%;
    transform: translate(0,-50%) !important;
    opacity: 0.5;
}
.arrowHover {
    color: #ffffff;
    opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/PopImage.vue